module.exports = __webpack_public_path__ + "static/media/expRed.eec8117d.svg";